import { cart } from "$lib/state/cart";
import { ADD_TO_CART_EVENT, dispatchCustomEvent } from "./events";
import { klaviyoAddToCart } from "./KlaviyoEvents";

/**@typedef {import ('$lib/types/index').matchProductsToCart} matchProductsToCart*/
/**@typedef {import ('$lib/types/index').PublicProduct} PublicProduct*/

export default class AddToCart {
  /**
   * @param {PublicProduct}product
   * @param {number} qty
   */
  async addToCartSingle(product, qty = 1) {
    try {
      const formData = new FormData();
      formData.append("sku", product.sku);
      formData.append("qty", String(qty));
      const cartStream = await fetch("/cart", {
        method: "POST",
        body: formData,
      });
      const response = await cartStream.json();

      if (cartStream.status === 200) {
        cart.set(response.cart);
        dispatchCustomEvent(
          ADD_TO_CART_EVENT,
          response.cart,
          product.sku,
          qty
        );
        klaviyoAddToCart(response.cart, product);
        return {
          response: true,
          skus: [product.sku],
        };
      } else {
        return {
          response: cartStream.status,
          error: {
            msg: response.message,
            error: true,
          },
          skus: [product.sku],
        };
      }
    } catch (error) {
      console.log(error);
    }
  }
  /** @param {matchProductsToCart[]}items */
  async addProductsToCart(items) {
    /**@type {string[]} */
    let skus = [];
    items.map((item) => skus.push(item.sku));
    try {
      const stream = await fetch("/cart/products", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: items }),
      });
      const response = await stream.json();
      if (stream.status === 200) {
        cart.set(response.cart);
        dispatchCustomEvent(
          ADD_TO_CART_EVENT,
          response.cart,
          skus,
          items.length,
        );
        items.map((product) => {
          dispatchCustomEvent(
            ADD_TO_CART_EVENT,
            response.cart,
            product.sku,
            product.quantity,
          );
          //@ts-ignore
          klaviyoAddToCart(response.cart, product);
        })
        return {
          response: true,
          skus: skus,
        };
      } else {
        return {
          response: stream.status,
          error: {
            msg: response.message,
            error: true,
          },
          skus: skus,
        };
      }
    } catch (error) {
      console.log(error);
    }
  }
}
